import * as React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { deleteAccount, selectSessionStatus, clearErrorMessage } from 'slices/sessionSlice'

import { CustomModal } from 'components/common'

type Props = {
  isOpen: boolean
  onSuccess: () => void
  onCancel: () => void
}

const AccountDelete: React.FC<Props> = ({ isOpen, onSuccess, onCancel }) => {
  const [modalErrorMessage, setModalErrorMessage] = React.useState<string | undefined>(undefined)
  const [submitted, setSubmitted] = React.useState(false)
  const { isRequesting, errorMessage } = useSelector(selectSessionStatus, shallowEqual)
  const dispatch = useDispatch()

  const handleDeleteClick = () => {
    setSubmitted(true)
    dispatch(deleteAccount())
  }

  const handleCancelClick = () => {
    setModalErrorMessage(undefined)
    onCancel()
  }

  React.useEffect(() => {
    if (isRequesting || !submitted) {
      return
    }
    if (errorMessage === '') {
      onSuccess()
    } else {
      setModalErrorMessage('保存できませんでした')
      dispatch(clearErrorMessage())
    }
    setSubmitted(false)
  }, [onSuccess, dispatch, submitted, isRequesting, errorMessage])

  return (
    <CustomModal
      isOpen={isOpen}
      title="アカウント削除"
      approveColor="danger"
      approveLabel="削除"
      errorMessage={modalErrorMessage}
      onCancel={handleCancelClick}
      onApprove={handleDeleteClick}
      onHideNotification={() => setModalErrorMessage(undefined)}
    >
      <div className="pb-4">アカウントを本当に削除しますか？この操作は取り消せません。</div>
    </CustomModal>
  )
}

export default AccountDelete
